import { render, staticRenderFns } from "./TablaCotizaciones.vue?vue&type=template&id=207499f6&scoped=true&"
import script from "./TablaCotizaciones.vue?vue&type=script&lang=js&"
export * from "./TablaCotizaciones.vue?vue&type=script&lang=js&"
import style0 from "./TablaCotizaciones.vue?vue&type=style&index=0&id=207499f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207499f6",
  null
  
)

export default component.exports